import { z } from 'zod';
import { IsoTimestamp, UserId } from './common.js';
export const MakeUpScheduleStatus = z.enum(['scheduled', 'consumed', 'expired']);
export const MakeUpSchedule = z.object({
    id: z.string().min(1).max(128),
    studentId: UserId,
    classroomId: z.string().min(1).max(64),
    startAt: IsoTimestamp,
    endAt: IsoTimestamp,
    durationSec: z.number().int().positive(),
    reason: z.string().min(1).max(500),
    note: z.string().max(500).optional(),
    status: MakeUpScheduleStatus.default('scheduled'),
    lockedBy: UserId.optional(),
    lockReason: z.string().max(200).optional(),
    bulkActionId: z.string().max(128).optional(),
    createdAt: IsoTimestamp,
    updatedAt: IsoTimestamp,
});
export const AccessHistoryAction = z.enum([
    'lock',
    'unlock',
    'schedule_makeup',
    'auto_lock_after_submit',
    'set_accommodations',
]);
export const AccessHistoryEntry = z.object({
    id: z.string().min(1).max(128),
    actorId: UserId,
    action: AccessHistoryAction,
    studentIds: z.array(UserId).min(1).max(50),
    makeUpScheduleId: z.string().max(128).optional(),
    reason: z.string().max(500).optional(),
    bulkActionId: z.string().max(128).optional(),
    createdAt: IsoTimestamp,
});
//# sourceMappingURL=make-up-schedule.js.map